import { render } from "./AddCollaborationPlan.vue?vue&type=template&id=68e38900"
import script from "./AddCollaborationPlan.vue?vue&type=script&lang=js"
export * from "./AddCollaborationPlan.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__